import styled from 'styled-components';

import { getColor, getSpace, mq } from '@stylesheets/tools';

export const getGradientOutline = () => {
  return `
      position: relative;

      &:before {
      content: '';
      position: absolute;
      inset: -1px;
      background: linear-gradient(88.85deg, #606ded 6.29%, #72f2ed 25.26%, #fc4cea 40.31%);
      filter: blur(3px);
      opacity: 0.8;
      border-radius: 3px;
    }
  `;
};

const StyledWishes = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  pointer-events: auto;
  background: ${getColor('black')};
  color: ${getColor('white')};
  opacity: 1;
  transition: opacity 400ms ease-in-out;
  overflow: hidden;

  filter: ${props => props.$defaultTheme && 'grayscale(1)'};

  @supports (height: 100dvh) {
    height: 100dvh;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: ${getSpace('xxs')};
    column-gap: ${getSpace('xxxxs')};
  }

  legend {
    margin-bottom: ${getSpace('xxxxs')};
  }

  button {
    color: ${getColor('black')};
  }

  .wishes__button {
    width: auto;
    height: 30px;
    border: 2px solid ${getColor('darkGray')};
    border-radius: 50px;
    background: ${getColor('white')};
    padding: 0 ${getSpace('xxxs')};
    transition: all 200ms ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${getSpace('xxxxs')};

    ${mq('m')} {
      height: 42px;
      padding: 0 ${getSpace('xxs')};
    }

    &--circle {
      width: 30px;
      border-radius: 50%;
      padding: 0;

      ${mq('m')} {
        width: 42px;
        padding: 0;
      }
    }

    &:hover,
    &[aria-expanded='true'] {
      border-color: ${getColor('white')};
      background: ${getColor('black')};
      color: ${getColor('white')};
    }

    span {
      text-transform: none;
    }

    svg {
      width: 14px;

      ${mq('m')} {
        width: 24px;
      }
    }
  }
`;

export default StyledWishes;
